export default __webpack_public_path__ + "static/media/1964Ann_А.33199529.jpg";